import {DrawInstrumentMenuData, DrawInstrumentType} from './draw_buttons/DrawInstrumentMenuData';
import {Sprite} from 'pixi.js';
import {InstumentButton} from './draw_buttons/InstumentButton';
import {SliderIconType} from './instument_top_block/slider/SliderIconType';

export class InstrumentButtons extends Sprite
{
    private drawButtons: InstumentButton[] = [];

    constructor(private onClick: (instrument: DrawInstrumentMenuData)=>void, private instruments: DrawInstrumentMenuData[]) {
        super();

        this.init();
    }

    private async init(): Promise<void> {
        let between: number = 72;
        let button: InstumentButton;

        this.instruments.forEach((instrument, index) => {
            button = new InstumentButton(instrument, this.onInstrumentClick.bind(this, instrument));
            this.drawButtons.push(button);
            this.addChild(button).x = -between * (this.instruments.length - 1) / 2 + index * between;
        });
    }

    public onInstrumentClick(instrument: DrawInstrumentMenuData): void {
        this.drawButtons.forEach((button, index) => {
            button.selected = button.instrument == instrument;
        });
        this.onClick(instrument);
    }
}
